import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import filters from './filters/index';
import titleMixin from './mixin/title_mixin';
import ToastPlugin from 'vue-toast-notification';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'primeicons/primeicons.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import VueAwesomePaginate from 'vue-awesome-paginate';
import 'vue-awesome-paginate/dist/style.css';
import GoogleSignInPlugin from "vue3-google-signin"
import clickOutside from './directives/click_outside';
// Form validation rules, registered once for the whole app.
import './utils/validation_rules';
import { registerServiceWorker } from './pwa/register_service_worker';
import { startInstallPromptCapture } from './pwa/install_prompt';

// Bound before the app mounts: `beforeinstallprompt` fires once and early, so
// the banner component cannot be the thing that listens for it.
startInstallPromptCapture();

const app = createApp(App);
app.mixin(titleMixin);

app.component('FontAwesomeIcon', FontAwesomeIcon);
// Closes row menus and popovers on an outside click or Escape.
app.directive('click-outside', clickOutside);

const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID
}

// Sentry.init({
//   app,
//   dsn: "",
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true
// });

// Set before mounting so the very first render can already use the filters.
app.config.globalProperties.$filters = filters;

// Make the admin installable as a PWA (production builds only).
registerServiceWorker();

app
  // .use(posthogPlugin)
  .use(VueAwesomePaginate)
  .use(GoogleSignInPlugin, gauthOption)
  .use(ToastPlugin)
  .use(store)
  .use(router)
  .mount('#app');
